import { AppHelper } from "../appHelper.js"
import { CommonApp, CommonAppProps, Context, Entity, Metadata } from "../core/components/commonApp.js";
import { History, ReminderHistoryAppProps } from "./history.js";
import { Helper } from "../core/util/helper.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { General } from "../../siteManagement/general.js";
import { SheetEventType, Sheet } from "../../siteManagement/sheet.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { Config } from "../core/config/config.js";
import { DialogHelper } from "../core/util/dialogHelper.js";
import { Reminder } from "../reminders/reminders.js";
import { StringKeyDictionary } from "../commonInterfaces.js";
import React from "react";
export class EditReminder extends React.Component<ReminderAppProps, any> {
    private _cache = {
        level: -1,
        comment: null,
        owner: null,
        ownerChanged: false
    };
    common = new AppHelper();
    translations: StringKeyDictionary<string> = null;
    deleteEnabled = true;
    historyEnabled = true;


    constructor(props) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
        this._initApp();
    }


    private _updateCache = (level, comment, owner) => {
        this._cache.comment = comment;
        this._cache.level = level;
        this._cache.owner = owner;
    }


    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            case "entity.Owner":
                if (value !== this._cache.owner) {
                    if (!this._cache.ownerChanged) {
                        this.props.entity.IsPrivate = false;
                        this._cache.ownerChanged = true;

                        if (!this.props.entity.IsNew) {
                            this.props.entity.Level++;
                            this.props.entity.Comment = "";
                        }
                    }
                } else {
                    //revert the changes
                    this.props.entity.IsPrivate = true;
                    this.props.entity.Level = this._cache.level;
                    this._cache.ownerChanged = false;

                    if (!this.props.entity.IsNew) {
                        this.props.entity.Comment = this._cache.comment;
                    }
                }
                break;
            //case "entity.Comment":
            //    this._cache.comment = value;
            //    break;
            default:
                break;
        }

        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    save = () => {
        if (this.common.validate()) {
            HTTPService.post<JsonResultClass<ReminderEntity>>(this.props.entity.IsNew ? "Tasks/Add" : "Tasks/Update", this.props.entity)
                .then((result) => {
                    if (result.Code === 0) {
                        Helper.updateEntity(this.props.entity, result.Data);
                        this.props.entity.IsNew = false;
                        NotificationHelper.showSuccessMessage(result.Message);
                        $(window).trigger("refreshReminders");
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                    this.common.handlePostSave(result.Code === 0, this._cache.ownerChanged);
                });
        }
    }

    remove = () => {
        DialogHelper.confirm(Config.translations.deleteMessage).then(isOK => {
            if (isOK) {
                const url = 'Tasks/Remove/' + this.props.entity.ISGuid;
                HTTPService.post<JsonResultClass>(url)
                    .then(result => {
                        if (result.Code === 0) {
                            NotificationHelper.showSuccessMessage(result.Message);
                            $(window).trigger("refreshReminders");
                            this.common.sheetWrapper.trigger(SheetEventType.ItemDeleted);
                            this.common.sheetWrapper.hide();
                        } else {
                            NotificationHelper.showErrorMessage(result.Message);
                        }
                    });
            }
        });
    }

    showHistory = (data?: Reminder[]) => {
        let itemWasSelected = false;
        const sheet = General.Sheet.Manager.createSheet();
        sheet.setTitle(Helper.hasValue(data) ? this.translations["WebSMS.Reminder.SelectReminder"] : this.translations["WebSMS.Reminder.ReminderHistory"]);
        sheet.bind(SheetEventType.RowClicked, (target) => {
            itemWasSelected = true;
            Helper.updateEntity(this.props.entity, target);
            this._updateCache(this.props.entity.Level, this.props.entity.Comment, this.props.entity.Owner);
            this.setState({});
        });
        if (Helper.hasValue(data)) {
            sheet.bind(SheetEventType.Close, () => {
                if (!itemWasSelected) {
                    this.common.sheetWrapper.hide();
                }
            });
        }
        Helper.getMetaData("reminderHistory")
            .then(metaData => {
                sheet.show(() => {
                    const historyProps: ReminderHistoryAppProps = {
                        existingData: Helper.hasValue(data) ? data : null,
                        reminderId: this.props.entity.ISGuid,
                        context: { contextType: "reminderHistory", key1: null, keyVal1: null },
                        entity: { IsNew: true, RecordRight: { CanRead: true, CanWrite: true }, IsWatchable: false, IsWatched: false },
                        metadata: metaData,
                        isWindow: true,
                        selectMode: Array.isArray(data) && data.length > 0,
                        dataSources: {},
                        title: Helper.hasValue(data) ? this.translations["WebSMS.Reminder.SelectReminder"] : this.translations["WebSMS.Reminder.ReminderHistory"]
                    };

                    sheet.mountContent(History, historyProps);
                });
            });
    }


    private _initApp = () => {

        this._updateCache(this.props.entity.Level, this.props.entity.Comment, this.props.entity.Owner);

        if (this.props.operation === Operation.Add) {
            this.props.entity.Url = window.location.href;
            this.props.entity.RelativeUrl = window.location.pathname.replace(Config.baseUrl, '') + window.location.search;
            this.common.sheetWrapper.setTitle(this.translations["WebSMS.Reminder.Add"]);
        } else if (this.props.operation === Operation.Edit) {
            this.common.sheetWrapper.setTitle(this.translations["WebSMS.Reminder.Edit"]);
            if (Array.isArray(this.props.existingReminders)) {
                if (this.props.existingReminders.length === 0) {
                    //add mode 
                } else if (this.props.existingReminders.length === 1) {
                    //edit mode
                    Helper.updateEntity(this.props.entity, this.props.existingReminders[0]);
                    this._updateCache(this.props.entity.Level, this.props.entity.Comment, this.props.entity.Owner);
                } else {
                    //edit mode with multiple entries => select reminder to edit 
                    this.showHistory(this.props.existingReminders);
                }
            }
        }
        this.props.entity.FullUrl = window.location.origin + Config.baseUrl + this.props.entity.RelativeUrl;
    }

    componentDidMount() {
        if (!this.props.entity.IsNew && !Helper.hasValue(this.props.entity.ReadAt)) {
            HTTPService.get<JsonResultClass<string>>("Tasks/MarkAsRead/" + this.props.entity.ISGuid)
                .then(result => {
                    this.props.entity.ReadAt = Helper.dates.toDate(result.Data);
                    this.setState({}, () => {
                        this.common.sheetWrapper.trigger(SheetEventType.SavedSuccessfully);
                    });
                });
        }
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}

export const initEdit = async (options: { sheet: Sheet, /* element: Element,*/ operation: Operation, reminderId?: string, targetUrl?: string }) => {
    const _defined = Helper.hasValue;
    const validId =
        options.operation === Operation.Edit
        && _defined(options.reminderId)
    //&& typeof options.reminderId === "number"
    //&& options.reminderId >= 0;
    const idParam = validId ? 'id=' + options.reminderId : "";

    HTTPService.chainBatch
        .add<JsonResultClass<ReminderEntity>>('Tasks/Init?' + idParam)
        .add<Metadata>(Helper.getMetaData("remindersQuickAdd"))
        .add(options.operation === Operation.Edit && _defined(options.targetUrl) ? "Tasks/GetGridData" + (_defined(options.targetUrl) ? ("?url=" + options.targetUrl) : "") : null)
        .promise()
        .then(result => {
            if (result[0].Code != 0) {
                NotificationHelper.showErrorMessage(result[0].Message)
                return;
            } else {
                const reminder = result[0].Data;
                const metaData = result[1];
                const existingReminders = result[2];

                const reminderEditProps: ReminderAppProps = {
                    entity: reminder,
                    metadata: metaData,
                    context: { contextType: "reminderEdit", key1: null, keyVal1: null },
                    isWindow: true,
                    operation: options.operation,
                    existingReminders: existingReminders,
                    reminderId: options.reminderId,
                    targetUrl: options.targetUrl,
                    handleMenuSelect: () => { },
                    enableMenuItem: () => true,
                    handleCreateValidator: null,
                    handleDataLoaded: () => { },
                    onChange: () => { },
                    handleFieldChange: () => { }
                }

                if (options.operation === Operation.Edit && Array.isArray(existingReminders) && existingReminders.length === 0) {
                    reminderEditProps.operation = Operation.Add;
                }

                // ReactDOM.render(React.createElement(EditReminder, reminderEditProps), options.element);
                options.sheet.mountContent(EditReminder, reminderEditProps);
            }
        });
}

export enum Operation {
    Add, Edit
}

export interface ReminderEntity extends Entity {
    Url: string;
    RelativeUrl: string;
    FullUrl: string;
    Id: number;
    Owner: string;
    Level: number;
    Comment: string;
    IsPrivate: boolean;
    ISGuid: string;
    ReadAt: Date;
}

interface ReminderContext extends Context {
    contextType: string;
}

export interface ReminderAppProps extends CommonAppProps {
    //metadata?: Metadata;
    context?: ReminderContext;
    reminderId?: string;
    targetUrl?: string;
    entity: ReminderEntity;
    //isWindow?: boolean;
    operation: any;//Innosoft.App.Reminders.Operation;
    existingReminders?: Reminder[];
    afterSaveCallback?: () => void;
}


